import F1CalendarGenerator from './components/F1CalendarGenerator';

function App() {
  return (
	<div className="container mx-auto p-4">
	  <F1CalendarGenerator />
	</div>
  );
}

export default App;